<template>
  <div class="wrap_knowledgeTalent wow fadeInUp">
    <el-row v-for="(itm,inx) in serviceArray" :key="inx">
      <el-col :span="2" class="header_block"></el-col>
      <el-col :span="20" class="header_block server_box">
        <div v-for="(item,index) in itm" :key="index" class="split_box">
          <div class="split_box_cont">
            <div class="split_box_img">
              <img :src="item.url" class="server_img" />
            </div>
            <div class="wrap_serve_cont">
              <div class="wrap_serve_dis">
                <p class="server_title">{{item.title}}</p>
                <p class="server_titleEng">{{item.titleEng}}</p>
              </div>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :span="2" class="header_block"></el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "knowledgeTalent",
  data() {
    return {
      serviceArray: [
        [
          {
            url: require("@/assets/imgs/teacher01.jpeg"),
            title: "郦波",
            titleEng:
              "南京师范大学文学院教授、博导多次登上央视《百家讲坛》担任《中国成语大会》、《中国汉字听写大会》嘉宾"
          },
          {
            url: require("@/assets/imgs/teacher02.jpeg"),
            title: "王鹰豪",
            titleEng:
              "99个魔方世界冠军中国魔方全能项第一，亚洲第四，二阶魔方速拧全国纪录保持者5次打破亚洲纪录，9次打破全国纪录《最强大脑》选手"
          }
        ],
        [
          {
            url: require("@/assets/imgs/teacher03.jpeg"),
            title: "宋少卫",
            titleEng:
              "著名青少年心理学专家清华大学心理学系学习科学实验室执行主任国内学习治疗创始人之一"
          },
          {
            url: require("@/assets/imgs/teacher04.jpeg"),
            title: "俞辰捷",
            titleEng:
              "第56届国际数学奥林匹克竞赛（IMO）金牌北大数学系在读研究生"
          }
        ],
        [
          {
            url: require("@/assets/imgs/teacher05.jpeg"),
            title: "郑才千",
            titleEng:
              " 世界记忆大师世界第一位20岁之前获得“世界记忆大师”终身荣誉称号的选手被誉为“文字信息记忆亚洲第一人”两小时内倒背千字文6天时间倒背如流《唐诗三百首》"
          },
          {
            url: require("@/assets/imgs/teacher06.jpeg"),
            title: "任自豪",
            titleEng:
              "《中国诗词大会》四期擂主微博知名国学文化博主红楼梦研究学会会员《神奇的汉字》第二季节目嘉宾 "
          }
        ],
        [
          {
            url: require("@/assets/imgs/teacher07.jpeg"),
            title: "谢金伯",
            titleEng:
              " 中国数独国家队教练中国数独国少队总教练北京市数独运动协会常务理事2020年世界谜题锦标赛出题负责人"
          },
          {
            url: require("@/assets/imgs/teacher08.jpeg"),
            title: "袁浩",
            titleEng:
              "思维导图官方认证导师八年教龄语文老师教育部“十三五”重点课题研究员国际思维导图TBLI官方认证讲师师从思维导图发明人东尼·博赞 "
          }
        ],
        [
          {
            url: require("@/assets/imgs/teacher09.jpeg"),
            title: "郎佳子彧",
            titleEng: "95后非物质文化遗产传承人北京大学2018级在读研究生 "
          },
          {
            url: require("@/assets/imgs/teacher10.jpeg"),
            title: "孙亚飞",
            titleEng:
              "青年化学家，清华大学化学博士10年化学知识的分享，写作将近百万字出版译著《锈蚀》、《诗意的原子》等科学松鼠会会员中国科普作家协会会员两度文津图书奖推荐书目获得者"
          }
        ]
      ]
    };
  },
  mounted() {
    this.$nextTick(() => {
      // 在dom渲染完后,再执行动画
      // const wow = new WOW({
      //   live: false
      // })
      // wow.init()
      new this.$wow.WOW({
        live:true
      }).init()
    })
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.wrap_knowledgeTalent {
  .header_block {
    min-height: 10px;
  }
}
.server_box {
  display: flex;

  .split_box {
    display: flex;
    flex: 1;
    justify-content: center;

    //  <div class="split_box_cont">
    //         <div class="split_box_img">
    //           <img :src="item.url" class="server_img" />
    //         </div>
    //         <div class="wrap_serve_cont">
    //           <div class="wrap_serve_dis">
    //             <p class="server_title">{{item.title}}</p>
    //             <p class="server_titleEng">{{item.titleEng}}</p>
    //           </div>
    //         </div>
    //       </div>



    .split_box_cont {
      width: 100%;
      display: flex;
      justify-content: center;
      margin-bottom: 2px;
      .split_box_img{
        width: 30%;
        padding-right: 20px;
        border-bottom: 1px dashed #999;
        padding-bottom: 15px;
    margin-bottom: 15px;
      }

      .server_img {
        width: 100%;
        border-radius: 50%;
        
      }
      .wrap_serve_cont {
        width: 45%;
        display: flex;
        align-items: center;
        border-bottom: 1px dashed #999;
        padding-bottom: 15px;
    margin-bottom: 15px;
        .wrap_serve_dis {
        }
      }
    }
  }
  .server_img {
    width: 50%;
  }
  .server_title {
    font-size: 22px;
    color: #363636;
  }
  .server_titleEng {
    font-size: 14px;
    color: #8d8d8d;
    margin-top: 8px;
    line-height: 20px;
  }
}
</style>



